import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { openAppointmentCalendarOption } from "../appointmentCalendar";

const CALENDAR_PROVIDER_OPTIONS = [
  { id: "google", labelKey: "NUTRITION_CALENDAR_BTN_GOOGLE" },
  { id: "outlook", labelKey: "NUTRITION_CALENDAR_BTN_OUTLOOK" },
  { id: "apple", labelKey: "NUTRITION_CALENDAR_BTN_APPLE" },
  { id: "ics", labelKey: "NUTRITION_CALENDAR_BTN_ICS" },
];

const AddToCalendarButton = ({ registrationData, calendlyAppointment = null }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);

  const handleProviderSelect = (provider) => {
    const result = openAppointmentCalendarOption({
      provider,
      registrationData,
      calendlyAppointment,
    });

    setIsOpen(false);

    if (!result.success) {
      const errorMessage = result.error || "";
      message.error(
        errorMessage.startsWith("NUTRITION_")
          ? t(errorMessage)
          : errorMessage || t("NUTRITION_CALENDAR_ERR_ADD")
      );
      return;
    }

    if (provider === "ics") {
      message.success(t("NUTRITION_CALENDAR_MSG_ICS_DOWNLOADED"));
      return;
    }

    if (provider === "apple") {
      message.success(t("NUTRITION_CALENDAR_MSG_OPENING_APPLE"));
      return;
    }

    message.success(t("NUTRITION_CALENDAR_MSG_OPENING"));
  };

  return (
    <div className="confirm-calendar-wrap" ref={containerRef}>
      {isOpen ? (
        <div className="confirm-calendar-menu" role="menu" aria-label={t("NUTRITION_CONFIRM_BTN_ADD_CALENDAR")}>
          {CALENDAR_PROVIDER_OPTIONS.map((option) => (
            <button
              key={option.id}
              type="button"
              role="menuitem"
              className="confirm-calendar-menu-item"
              onClick={() => handleProviderSelect(option.id)}
            >
              {t(option.labelKey)}
            </button>
          ))}
        </div>
      ) : null}
      <button
        type="button"
        className="btn-ghost confirm-calendar-btn"
        aria-expanded={isOpen}
        aria-haspopup="menu"
        onClick={() => setIsOpen((open) => !open)}
      >
        {t("NUTRITION_CONFIRM_BTN_ADD_CALENDAR")}
      </button>
    </div>
  );
};

export default AddToCalendarButton;
